import React, { useState } from "react";
import { Product } from "@/types/types";
import { IconButton } from "@JohnLewisPartnership/jl-design-system/dist/elements/button/IconButton";
import { ArrowRightOutlined } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/ArrowRightOutlined";
import { Badge } from "@JohnLewisPartnership/jl-design-system/dist/components/badge/Badge";
import { dispatchMonetateQEvent } from "@/utils/monetate/monetateQ";
import { PricePromiseDrawer } from "./PricePromiseDrawer";
import styles from "./PricePromiseUIV2.module.scss";

interface PricePromiseProps {
  product: Product;
  isInGroup?: boolean;
  isJohnLewisProduct?: boolean;
  extendPricePromiseClickArea?: boolean;
}

const PricePromiseUIV2: React.FC<PricePromiseProps> = ({
  product,
  isInGroup = false,
  isJohnLewisProduct = false,
  extendPricePromiseClickArea = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  function handleDrawerButtonClick() {
    setIsOpen(true);
    dispatchMonetateQEvent("WPDP | Price Promise Info Displayed");
  }

  function handlePricePromiseURLClick(
    e: React.MouseEvent<HTMLAnchorElement>,
  ): void {
    e.preventDefault();
    dispatchMonetateQEvent("pdp:price-promise:badge:click");
    const hrefTarget = e.currentTarget.getAttribute("href") || "";
    window.location.href = hrefTarget;
  }

  return (
    <>
      <div
        className={`${styles.pricePromiseContainer} ${isInGroup ? styles.pricePromiseGroupContainer : ""}`}
        data-testid="redesigned-price-promise-container"
      >
        {extendPricePromiseClickArea ? (
          <>
            <button
              onClick={handleDrawerButtonClick}
              className={styles.extendedClickAreaButton}
              aria-label="How our price promise works"
              data-testid="extended-click-area-button"
            >
              <div
                data-testid="price-promise-badge-wrapper"
                onClick={() => {
                  dispatchMonetateQEvent("pdp:price-promise:badge:click");
                }}
              >
                <Badge className={styles.badge} label="Price promise" />
              </div>
              <div className={styles.extendedClickAreaIconWrapper}>
                <ArrowRightOutlined size="medium" />
              </div>
            </button>
          </>
        ) : (
          <>
            <div
              data-testid="price-promise-badge-wrapper"
              onClick={() => {
                dispatchMonetateQEvent("pdp:price-promise:badge:click");
              }}
            >
              <Badge className={styles.badge} label="Price promise" />
            </div>

            <IconButton
              aria-label="How our price promise works"
              IconComponent={ArrowRightOutlined}
              size="small"
              variant="clear-dark"
              onClick={handleDrawerButtonClick}
            />
          </>
        )}
        <PricePromiseDrawer
          product={product}
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          isJohnLewisProduct={isJohnLewisProduct}
        />
      </div>
    </>
  );
};

export default PricePromiseUIV2;
